/** Formatea un número a máximo 2 decimales, sin ceros innecesarios.
 *  @example _2d(8) → "8", _2d(8.5) → "8.5", _2d(8.555) → "8.56" */
export const _2d = (n: number): string => {
  const s = n.toFixed(2);
  return s.replace(/\.?0+$/, "");
};

/** Formatea un número con separador de miles y hasta 2 decimales (sin ceros
 *  innecesarios), en formato es-CO (miles ".", decimal ",").
 *  @example _miles(1250000) → "1.250.000", _miles(8.5) → "8,5" */
export const _miles = (n: number): string =>
  n.toLocaleString("es-CO", { maximumFractionDigits: 2 });
